import { CircleCheckBig, Copy } from 'lucide-react';
import { useState } from 'react';

import { ACCENT } from '@shared/constants/colors';
import { ID_AR_LINK_ATTRIBUTE, ID_ARTICLE_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { showToast } from '@shared/utils/showToast/showToast';

import cls from './Article.module.scss';

export const Article = () => {
  const data = useAppSelector((state) => state.product.data.props[ID_ARTICLE_ATTRIBUTE]);
  const link = useAppSelector((state) => state.product.data.props[ID_AR_LINK_ATTRIBUTE]);

  const [copy, setCopy] = useState(false);

  if (!data?.values[0]?.value) return null;

  const onClickHandler = () => {
    if (copy) return;
    navigator.clipboard.writeText(data?.values[0]?.value).then(() => {
      setCopy(true);
      showToast('Ссылка скопирована');
    });
    setTimeout(() => {
      setCopy(false);
    }, 2000);
  };

  return (
    <div
      onClick={onClickHandler}
      className={cls.wrap}
    >
      <div className={cls.label}>Артикул:</div>
      <div className={cls.value}>{data.values[0].value}</div>
      <div className={cls.icon}>
        {copy ? (
          <CircleCheckBig
            size={16}
            color={ACCENT}
          />
        ) : (
          <Copy
            size={16}
            color={ACCENT}
          />
        )}
      </div>

      {link?.values[0].value && (
        <a
          className={cls.ar}
          target={'_blank'}
          href={link.values[0].value}
        >
          открыть модель в ar
        </a>
      )}
    </div>
  );
};
